import React from "react";

import Image from "next/image";

import Bolt from "assets/iconsv2/bolt-16.svg";
import ComputerChip from "assets/iconsv2/computer-chip-16.svg";
import ArrowUpCircle from "assets/iconsv2/arrow-up-circle-16.svg";
import ActionPanel from "assets/home/one-up-your-productivity/action-panel.png";
import AppMahjong from "assets/home/one-up-your-productivity/app-mahjong.png";

import Container from "components/Container";

import CheckCircle from "assets/iconsv2/check-circle-16.svg";

import BlockCallToAction from "./BlockCallToAction";

import styles from "./EasyAsInstalled.module.css";
import Subtitle from "./Subtitle";
import StoreCommandExample from "./StoreCommandExample";

const EasyAsInstalled: React.FC = () => {
  return (
    <>
      <Subtitle>
        <h3>
          It&rsquo;s as easy as&nbsp;
          <em className={styles.green}>
            installed <CheckCircle className="icon" />
          </em>
        </h3>

        <p>
          Say hello to the Store. A home for Extensions published by our community of Developers using our API. Find
          extensions to the tools you use in your day-to-day.
        </p>
      </Subtitle>
      <Container size="lg">
        <div className={styles.oneUpProductivity}>
          <div className={styles.text}>
            <div className={styles.icon}>
              <ArrowUpCircle />
            </div>
            <h4>One up your productivity</h4>

            <p>
              On top of the core Raycast Extensions already built in, you can install Extensions built by Developers
              from the community. Everything you&rsquo;ve asked for, in one place. Search and browse Extensions for your
              tools, actions and more.
            </p>

            <a href="/store" className={styles.button}>
              Browse Extensions
            </a>
          </div>

          <div className={styles.image}>
            <StoreCommandExample />
          </div>
        </div>

        <div className={styles.collection}>
          <div className={styles.lightweight}>
            <div className={styles.text}>
              <div className={styles.icon}>
                <Bolt />
              </div>
              <h4>Lightweight and snappy</h4>

              <p>
                Designed to be seamless and instant. View an Extension and hit &nbsp;<code>↵</code>&nbsp;to simply
                install it in milliseconds.
              </p>
            </div>

            <div className={styles.image}>
              <Image src={ActionPanel} width={332} height={278} alt="Raycast Action Panel in Action" layout="fixed" />
            </div>
          </div>
          <div className={styles.evergrowing}>
            <div className={styles.text}>
              <div className={styles.icon}>
                <ComputerChip />
              </div>
              <h4>An evergrowing collection</h4>

              <p>
                Control Spotify or Apple Music with a hit of a button. Search through Figma, Notion, and Xcode. Check
                your internet speed and the weather without needing the browser, or even play a game of Snake.
              </p>
            </div>

            <div className={styles.image}>
              <Image
                src={AppMahjong}
                width={720}
                height={364}
                alt="Mahjong-style image with icons of tools that Raycast integrates with"
                layout="fixed"
              />
            </div>
          </div>
        </div>

        <BlockCallToAction href="/store">Explore the store</BlockCallToAction>
      </Container>
    </>
  );
};

export default EasyAsInstalled;
